import { render } from "./IconOk.vue?vue&type=template&id=be38cd62"
import script from "./IconOk.vue?vue&type=script&lang=js"
export * from "./IconOk.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__